/**
 * Live credit shortfall for a project's credit-blocked design pages.
 *
 * The backend recomputes `credit_status` on every design-pages fetch and SSE
 * broadcast, so this reads as live state rather than the amount frozen into
 * the chat gate message when the run stopped. After a top-up the numbers
 * shrink — and disappear once nothing is blocked — without a reload.
 */
import type { DesignCreditStatus } from '../services/designService';
import { useGetDesignPagesQuery } from '../store/services/designApi';

export type { DesignCreditStatus };
export {
  designCreditCopy,
  designCreditShortfall,
  pageCreditCopy,
  pageCreditShortfall,
} from '../utils/designCreditCopy';

/** Read the project's live design credit status, or null when nothing is blocked. */
export function useDesignCreditStatus(
  projectId?: string | null,
): DesignCreditStatus | null {
  const { currentData } = useGetDesignPagesQuery(
    { projectId: projectId ?? '', light: true, includePlanned: true },
    { skip: !projectId },
  );
  const status = currentData?.credit_status;

  return status && status.blocked_pages?.length ? status : null;
}
